import React, {useState, useEffect} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";


const UserWalletEdit = ()=>{
     const [user, setUser ] = useState('');
     const [bookBalance, setBookBalance ] = useState('');
     const [availableBalance, setAvailableBalance ] = useState('');
     const [dateLastWithdrawal, setDateLastWithdrawal ] = useState('');
     const [amountLastWithdrawal, setAmountLastWithdrawal ] = useState('');
    const [redirect, setRedirect] = useState(false);


    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`userWallet/${id}`);
                 setUser(data.user);
                 setBookBalance(data.book_balance);
                 setAvailableBalance(data.available_balance);
                 setDateLastWithdrawal(data.date_last_withdrawal);
                 setAmountLastWithdrawal(data.amount_last_withdrawal);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`userWallet/${id}`, {
            user,
            bookBalance,
            availableBalance,
            dateLastWithdrawal,
            amountLastWithdrawal,
        });
        console.log(data);
        setRedirect(true);
    };

    if(redirect){
         return <Navigate to={'/userWallet'} />
    }
    return (
        <Wrapper pageTitle={'Edit UserWallet'}>
            <InnerNav createLink={'/userWalletCreate'} listLink={'/userWallet'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">User </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="User" value={user}
                        onChange = {e => setUser(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">BookBalance </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="BookBalance" value={bookBalance}
                        onChange = {e => setBookBalance(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">AvailableBalance </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="AvailableBalance" value={availableBalance}
                        onChange = {e => setAvailableBalance(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">DateLastWithdrawal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="DateLastWithdrawal" value={dateLastWithdrawal}
                        onChange = {e => setDateLastWithdrawal(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">AmountLastWithdrawal </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="AmountLastWithdrawal" value={amountLastWithdrawal}
                        onChange = {e => setAmountLastWithdrawal(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default UserWalletEdit;